<template>
  <div class="home">
    <Welcome v-if="!showPracticeBlock"/>
    <SorobanSetup v-show="!showPracticeBlock" @practiceStarted="practiceStarted"/>

    <v-btn small fixed left top dark fab class="primary" v-if="showPracticeBlock" @click="practiceFinished">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <Parameters v-if="showPracticeBlock" />

    <Practice v-if="showPracticeBlock&&!$store.getters.loading"  />
  </div>
</template>

<script>
import Welcome from '@/components/Practice/Welcome.vue'
import SorobanSetup from '@/components/Practice/SorobanSetup.vue'
import Practice from '@/components/Practice/Practice.vue'
import Parameters from '@/components/Practice/Parameters.vue'

export default {
  data(){
    return{
      showPracticeBlock : false,
      practiceData: {}
    }
  },
  components: {
    Welcome,
    SorobanSetup,
    Practice,
    Parameters,
  },
  methods:{
    practiceStarted(){
      this.showPracticeBlock = true;
    },
    practiceFinished(){
      this.showPracticeBlock = false;
    }
  },
  computed:{

  }
}
</script>

<style lang="scss" scoped>

</style>
